export default "__VITE_ASSET__CGLLu2$E__"